import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemePlanSpotTeklifVer_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemePlanSpotTeklifVer_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Firma_ParametreByName: any[];
  Get_Firma_ParametreByName_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  YuklemePlanv2_GetSpotTalepById: any[];
  YuklemePlanv2_GetSpotTalepById_dummy: any[];
  GetMailBody_SpotTedarikciTeklifBildirim: string;
  GetMailBody_SpotTedarikciTeklifBildirim_dummy: string;
  YuklemePlanV2_SpotTeklifKaydet: number;
  YuklemePlanV2_SpotTeklifKaydet_dummy: number;
  SendMail: boolean;
  SendMail_dummy: boolean;
  Notify: boolean;
  Notify_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  isComp586230Enabled: "enabled" | "disabled";
  isComp241317Enabled: "enabled" | "disabled";
}

export class YuklemePlanSpotTeklifVer_ScreenBase extends React.PureComponent<
  IYuklemePlanSpotTeklifVer_ScreenProps,
  any
> {
  yuklemeplanspotteklifver_241317_value_kuikaDateRef: React.RefObject<any>;
  yuklemeplanspotteklifver_831046_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "665c6dba-7f5f-4ef8-8a8f-5a15283d58e9",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 553910, PropertyName: "value", Value: "Yükleme Plan Teklif Ver" },
        { Id: 887086, PropertyName: "value", Value: "Yükleme No" },
        { Id: 94683, PropertyName: "value", Value: "Araç Tipi" },
        { Id: 586230, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 71255, PropertyName: "value", Value: "Planlanan Yükleme Tarihi" },
        { Id: 241317, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 653505, PropertyName: "value", Value: "Teklif Tutari" },
        { Id: 571924, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 414872, PropertyName: "value", Value: "Tahmini Varış Tarihi" },
        { Id: 831046, PropertyName: "placeholder", Value: "Select Date..." },
        {
          Id: 796853,
          PropertyName: "value",
          Value: "Notlar (En fazla 500 karakter)",
        },
        { Id: 868012, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 723285, PropertyName: "label", Value: "Teklif Gönder" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemeplanspotteklifver_586230_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifver_241317_value_kuikaDateRef = React.createRef();
    this.yuklemeplanspotteklifver_571924_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifver_831046_value_kuikaDateRef = React.createRef();
    this.yuklemeplanspotteklifver_868012_value_kuikaTextInputRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Firma_ParametreByName: [],
      YuklemePlan_Get_MasterById: [],
      YuklemePlanv2_GetSpotTalepById: [],
      GetMailBody_SpotTedarikciTeklifBildirim: "",
      YuklemePlanV2_SpotTeklifKaydet: 0,
      SendMail: false,
      Notify: false,
      GoBack: "",
      isComp586230Enabled: "disabled",
      isComp241317Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifver", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemePlanSpotTeklifVerPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifver", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifver", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemePlanSpotTeklifVerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemeplanspotteklifver_586230_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.aracTipi ?? undefined,
      yuklemeplanspotteklifver_241317_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)
          ?.planlananYuklemeTarihi ?? undefined,
      yuklemeplanspotteklifver_571924_value:
        this.state.YuklemePlanv2_GetSpotTalepById?.at?.(0)?.teklifTutari ??
        undefined,
      yuklemeplanspotteklifver_831046_value:
        this.state.YuklemePlanv2_GetSpotTalepById?.at?.(0)?.tahminiVaris ??
        undefined,
      yuklemeplanspotteklifver_868012_value:
        this.state.YuklemePlanv2_GetSpotTalepById?.at?.(0)?.aciklama ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemePlanSpotTeklifVerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanSpotTeklifVerPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanSpotTeklifVerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      ParametreAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("SpotAktarimMailTo", "string"),
        "string"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TalepId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TalepId ?? this.props.screenInputs.talepid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifVer/YuklemePlanSpotTeklifVerPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Firma_ParametreByName =
      result?.data.get_Firma_ParametreByName;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    formVars.yuklemeplanspotteklifver_586230_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );
    formVars.yuklemeplanspotteklifver_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );
    stateVars.YuklemePlanv2_GetSpotTalepById =
      result?.data.yuklemePlanv2_GetSpotTalepById;
    formVars.yuklemeplanspotteklifver_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
          ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
            ? stateVars.YuklemePlanv2_GetSpotTalepById[0].teklifTutari
            : null
          : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? this.state.YuklemePlanv2_GetSpotTalepById[0].teklifTutari
          : null
      );
    formVars.yuklemeplanspotteklifver_831046_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
        ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? stateVars.YuklemePlanv2_GetSpotTalepById[0].tahminiVaris
          : null
        : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
        ? this.state.YuklemePlanv2_GetSpotTalepById[0].tahminiVaris
        : null
    );
    formVars.yuklemeplanspotteklifver_868012_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
          ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
            ? stateVars.YuklemePlanv2_GetSpotTalepById[0].aciklama
            : null
          : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? this.state.YuklemePlanv2_GetSpotTalepById[0].aciklama
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanSpotTeklifVerPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTeklifVerPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplanspotteklifver_586230_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );

    formVars.yuklemeplanspotteklifver_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );

    formVars.yuklemeplanspotteklifver_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
          ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
            ? stateVars.YuklemePlanv2_GetSpotTalepById[0].teklifTutari
            : null
          : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? this.state.YuklemePlanv2_GetSpotTalepById[0].teklifTutari
          : null
      );

    formVars.yuklemeplanspotteklifver_831046_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
        ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? stateVars.YuklemePlanv2_GetSpotTalepById[0].tahminiVaris
          : null
        : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
        ? this.state.YuklemePlanv2_GetSpotTalepById[0].tahminiVaris
        : null
    );

    formVars.yuklemeplanspotteklifver_868012_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlanv2_GetSpotTalepById !== undefined
          ? stateVars.YuklemePlanv2_GetSpotTalepById?.length > 0
            ? stateVars.YuklemePlanv2_GetSpotTalepById[0].aciklama
            : null
          : this.state.YuklemePlanv2_GetSpotTalepById?.length > 0
          ? this.state.YuklemePlanv2_GetSpotTalepById[0].aciklama
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemePlanSpotTeklifVerComponent_723285_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifver_571924_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Dorse Plaka Zorunludur",
      formName: "yuklemeplanspotteklifver_571924_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
      TedarikciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
            : null
        ),
        "string"
      ),
      TeklifTutari_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toDecimal(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanspotteklifver_571924_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TahminiVaris_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanspotteklifver_831046_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Aciklama_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanspotteklifver_868012_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TalepId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TalepId ?? this.props.screenInputs.talepid,
        "Guid"
      ),
      templateId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName !== undefined
            ? stateVars.Get_Firma_ParametreByName?.length > 0
              ? stateVars.Get_Firma_ParametreByName[0].parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName?.length > 0
            ? this.state.Get_Firma_ParametreByName[0].parametreDegeri
            : null
        ),
        "string"
      ),
      subject_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Tedarikçi tarafından teklif oluşturuldu / güncellendi",
          "string"
        ),
        "string"
      ),
      sender_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      bcc_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      fileAttachments_2: ReactSystemFunctions.convertToTypeByName(``, "string"),
      language_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      body_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_SpotTedarikciTeklifBildirim
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifVer/YuklemePlanSpotTeklifVerComponent_723285_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_SpotTedarikciTeklifBildirim =
      result?.data.getMailBody_SpotTedarikciTeklifBildirim;
    stateVars.YuklemePlanV2_SpotTeklifKaydet =
      result?.data.yuklemePlanV2_SpotTeklifKaydet;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTeklifVerComponent_723285_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTeklifVerComponent_723285_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "04491ad1_79b3_e9f7_80ae_f90fb0efd370_notify",
        this.defaultML,
        "Teklif Gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemePlanSpotTeklifVerPageInit();
    }
  }
}
